export default function getQualityTagMapping(qualityTag) {
  if (!qualityTag) return null
  const tagValue = qualityTag.split(':')?.[0]
  const mapping = {
    0: 'meetsQualityStandards',
    1: 'informationObscured',
    2: 'missingPages',
    3: 'wrongCaptureMode',
    4: 'motionBlurOrOutOfFocus',
    5: 'overUnderExposed',
    6: 'improperlyCropped',
    7: 'extraMaterialInFrame',
    8: 'wrongImageOrientation',
    9: 'skewed',
    10: 'reflections',
    11: 'duplicate',
    12: 'defective',
    13: 'other',
    14: 'multiple',
  }
  return mapping?.[tagValue]
}
